import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'wave-saw-tool', 'WaveSawTool', [["path",{"d":"M3 12h5l4 8v-16l4 8h5","key":"svg-0"}]]);